import { jsx as _jsx } from "react/jsx-runtime";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import DraggableBox from "../../DraggableBox";
import classNames from "../../../../helpers/classNames";
import addPropToAllChildren from "../../../../helpers/addPropToAllChilds";
import useRepeatableRepeaterProps from "../../../../hooks/draggables/useRepeatableRepeaterProps";
const DraggableRepeatableSlider = ({ item: { id, props, children }, elementId, ...rest }) => {
    const { props: repeatableRepeaterProps, repeatable, items, } = useRepeatableRepeaterProps(props?.repeater, 30);
    const handleDrop = (e) => {
        e.preventDefault();
        rest.onDrop(e, e.target?.getAttribute("editor-key") === id);
    };
    return (_jsx("div", { className: classNames(props?.className || "h-[300px]"), "editor-key": id, "editor-has-childs": "true", ...repeatableRepeaterProps, ...rest, children: _jsx(Swiper, { navigation: false, modules: [Pagination, Navigation], slidesPerView: 1.5, spaceBetween: 10, pagination: {
                clickable: true,
                dynamicBullets: true,
            }, watchOverflow: true, breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
            }, "editor-focuskey": id, children: items?.map((item) => (_jsx(SwiperSlide, { "editor-focuskey": id, onDrop: handleDrop, children: _jsx(DraggableBox, { itemId: id, elementId: elementId, childs: addPropToAllChildren(children, {
                        repeatableRepeater: repeatable?.id,
                        repeatableRepeaterItem: item?.id,
                    }) || [], itemProps: props }) }, item.id))) }) }));
};
export default DraggableRepeatableSlider;
//# sourceMappingURL=DraggableRepeatableSlider.js.map